import { Page } from '@/core/architecture'

import { CustomProfileEditWallPaperTemplate } from './template'
import { useViewModel } from './viewModel'

export const CustomProfileEditWallPaper: Page = () => {
  const { state, actions } = useViewModel()

  return <CustomProfileEditWallPaperTemplate state={state} {...actions} />
}
